export const IAH_SITE_SECTION_ID = 'iah-airport';
export const HOU_SITE_SECTION_ID = 'hou-airport';
export const EFD_SITE_SECTION_ID = 'efd-airport';
export const SPACEPORT_SITE_SECTION_ID = 'spaceport';
export const CORPORATE_SITE_SECTION_ID = 'corporate';
export const GATEWAY_SITE_SECTION_ID = 'gateway';

export enum SiteSectionIds {
	IAH = IAH_SITE_SECTION_ID,
	HOU = HOU_SITE_SECTION_ID,
	EFD = EFD_SITE_SECTION_ID,
	Spaceport = SPACEPORT_SITE_SECTION_ID,
	Corporate = CORPORATE_SITE_SECTION_ID,
	Gateway = GATEWAY_SITE_SECTION_ID,
}
